import { defineStore } from 'pinia';

export const useDisplayStore = defineStore('display', {
	state: () => ({
		isDesktop: window.innerWidth > 1280,
		isSmallScreen: window.innerWidth < 768,
		isExtraSmallScreen: window.innerWidth < 600,
	}),
	actions: {
		checkDisplay() {
			if (window.innerWidth > 1280) {
				this.isDesktop = true;
			} else if (window.innerWidth <= 1280) {
				this.isDesktop = false;
			}
		},
		checkSmallScreen() {
			if (window.innerWidth > 768) {
				this.isSmallScreen = false;
			} else if (window.innerWidth <= 768) {
				this.isSmallScreen = true;
			}
		},
		checkExtraSmallScreen() {
			if (window.innerWidth > 600) {
				this.isExtraSmallScreen = false;
			} else if (window.innerWidth <= 600) {
				this.isExtraSmallScreen = true;
			}
		},
	},
});
